import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeaderBoardRoutingModule } from './leaderboard.routing.module';
import { LeaderboardComponent } from './components/leaderboard/leaderboard.component';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  declarations: [LeaderboardComponent],
  imports: [
    CommonModule,
    LeaderBoardRoutingModule,
    SharedModule
  ]
})
export class LeaderboardModule { }
